import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-admin-electable-signs-add',
  templateUrl: './admin-electable-signs-add.component.html'
})
export class AdminElectableSignsAddComponent implements OnInit {
  @Input() formdata;
  @Input() institutiontypes;
  @Input() signlist;
  @Input() institutionlist;
  @Output() doSave = new EventEmitter();
  @Output() doCancel = new EventEmitter();
form;
  
  id;

  constructor(
    private fb: FormBuilder,
    private router: Router) { }

  ngOnInit() {
    this.form = this.fb.group({
      id: ['', ''],
      signId: ['', ''],
      signName: ['', ''],
      signAbbreviation: ['', ''],
      institutionId: ['', ''],
      institutionIdName: ['', ''],
      shortName: ['', ''],
      institutionTypeId: ['', ''],
      institutionTypeIdName: ['', '']
    });
    this.router.events.subscribe(r => {
      if (r instanceof NavigationEnd) {
        this.form.reset();
      }
    });
  }

  setInstitutionType(evt) {
    const idx = this.institutiontypes.findIndex(x => x.value === +evt.value);
    this.form.patchValue({ institutionTypeId: evt.value, institutionTypeIdName: this.institutiontypes[idx].label, institutionId: '', institutionIdName: '', shortName: '' });
  }

  saveElectableSign() {
    this.doSave.emit(this.form.value);
    this.form.reset();
  }

  cancel() {
    this.doCancel.emit();
  }

  getSignTypeBySignId(evt) {
    this.form.patchValue({ signId: evt.value.id, signName: evt.value.name, signAbbreviation: evt.value.abbreviation });
  }

  setInstitution(evt) {
    this.form.patchValue({ institutionId: evt.value.id, institutionIdName: evt.value.name, shortName: evt.value.shortName, institutionTypeId: '', institutionTypeIdName: '' });
  }

}
